import React from "react";
import Autopara from "../Autopara/Autopara";

const images = [
  "https://img.freepik.com/free-photo/medium-shot-people-work-meeting_23-2149304769.jpg",
  "https://static.vecteezy.com/system/resources/thumbnails/014/770/514/small/executives-touch-human-resource-network-structure-hr-effective-management-and-recruitment-of-hr-effective-organizational-structure-training-employment-practice-photo.jpg",
  "https://img.freepik.com/free-photo/people-learning-language-work-full-shot_23-2149300731.jpg",
];

const paragraphText = `
  <strong>Human Resources (HR) Training</strong> equips learners with 
  recruitment, employee engagement, and payroll management skills.<br/><br/>
  Modules include <span style="color: teal; font-weight: bold;">talent acquisition</span>, 
  <span style="color: teal; font-weight: bold;">performance management</span>, 
  and <span style="color: teal; font-weight: bold;">HR tools</span>.
`;

function AutoparaHR() {
  return <Autopara images={images} text={paragraphText} />;
}

export default AutoparaHR;
